import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_PROD } from "../consts.js"

export const priveDemo = {
	"prive-demo-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_PROD }
}
